/* global console */
import EventSource, { EventSourceInitDict } from "eventsource";
import { getHeaders, mapErrorToMessage } from "../axios";
import NotificationManager from "../../common/notification/NotificationManager";
import { API_CALL_NOTIFICATION } from "../constants/notification";

export interface EventsConfig {
  paramPath: string;
  openCallback?: any;
  messageCallback: any;
  errorCallback?: any;
}

let eventSource: EventSource;

export const subscribeToHost = async (config: EventsConfig) => {
  // eslint-disable-next-line no-undef
  console.log("initializing new SEE connection to ", config.paramPath);

  if (eventSource) {
    eventSource.onopen = null;
    eventSource.onmessage = null;
    eventSource.onerror = null;
    eventSource.close();
    eventSource = null;
    // eslint-disable-next-line no-undef
    console.log("old SEE connection closed");
  }

  let headers = undefined;
  try {
    headers = await getHeaders(false);
  } catch (e) {
    const messageAndTitle = mapErrorToMessage(e);
    NotificationManager.addNotification({
      title: messageAndTitle.title,
      message: messageAndTitle.message,
      key: API_CALL_NOTIFICATION,
      type: "warning",
      closable: true,
      removeOnClose: true,
      isTemporary: false,
    });
  }

  if (headers) {
    const eventSourceInitDict: EventSourceInitDict = { headers: headers, rejectUnauthorized: true };

    try {
      eventSource = new EventSource(`${config.paramPath}`, eventSourceInitDict);

      eventSource.onopen = () => {
        config.openCallback();
      };

      eventSource.onmessage = (ev) => {
        try {
          // old code, not sure if it's still needed (in case the data contains encoded characters, this will be changed)
          config.messageCallback(JSON.parse(decodeURIComponent(ev.data)));
        } catch (e) {
          console.error(`Error decoding event data: ${ev.data}`);
          try {
            config.messageCallback(JSON.parse(ev.data));
          } catch (e) {
            console.error(`Error parsing event data: ${ev.data}`);
            config.errorCallback({ type: "error", message: "Failed to parse data" });
          }
        }
      };

      eventSource.onerror = (event) => {
        config.errorCallback(event);
      };

      // eslint-disable-next-line no-undef
      console.log("new SEE connection ready");
    } catch (e) {
      // eslint-disable-next-line no-undef
      console.error(`error creating EventSource `, e);
    }
  }
};
